module.exports = __webpack_public_path__ + "c8761e3fce3fc4d4a5af20afcd2bc017.png";